<button
  mat-icon-button
  class="ml-1"
  matTooltip="{{ 'tooltips.Notifications' | translate }}"
  [matMenuTriggerFor]="notificationsMenu"
  (menuClosed)="menuClosed()"
  [matBadge]="unreadNotifications.length"
  [matBadgeHidden]="!unreadNotifications.length"
  matBadgeColor="warn"
  matBadgeSize="medium"
>
  <fa-icon icon="bell" size="lg"></fa-icon>
</button>

<mat-menu class="LOSx-notifications-menu" #notificationsMenu="matMenu" [overlapTrigger]="false">
  @if (unreadNotifications.length === 0) {
    <div class="layout-column align-center-center no-notifications">
      <mat-icon class="no-notifications-icon">
        <span class="material-icons">{{ 'labels.menus.Notifications' | translate }}</span>
      </mat-icon>
      <p>{{ 'labels.text.No notifications' | translate }}</p>
    </div>
  }

  @for (notification of unreadNotifications; track notification) {
    <button mat-menu-item class="unread" [routerLink]="[routeMap[notification.objectType], notification.objectId]">
      {{ notification.content }}*<br />
      <span class="time">[{{ notification.createdAt }}]</span>
    </button>
  }

  @for (notification of displayedReadNotifications; track notification) {
    <button mat-menu-item [routerLink]="[routeMap[notification.objectType], notification.objectId]">
      {{ notification.content }}<br />
      <span class="time">[{{ notification.createdAt }}]</span>
    </button>
  }
</mat-menu>
